import { render, staticRenderFns } from "./SupportTooltip.vue?vue&type=template&id=0019abae&scoped=true"
import script from "./SupportTooltip.vue?vue&type=script&lang=js"
export * from "./SupportTooltip.vue?vue&type=script&lang=js"
import style0 from "./SupportTooltip.vue?vue&type=style&index=0&id=0019abae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019abae",
  null
  
)

export default component.exports